import React from "react";

function Button({ children, color, classN, type }) {
  return (
    <button
      type={type ? type : "button"}
      className={`w-full bg-${
        color ? color : "orange-500"
      } rounded-lg p-2 shadow-xl font-semibold text-lg ${classN} `}
    >
      {children}
    </button>
  );
}

export default Button;
